import { Skeleton } from '@react/chakra';

import type { JSX } from 'react';

export function PostSkeleton(): JSX.Element {
  return (
    <Skeleton
      h='900px'
      borderRadius='8px'
      bgColor='gray.700'
      transitionDuration='.15s'
      transitionTimingFunction='cubic-bezier(.4, 0, .2,1)'
      transitionProperty='color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter'
    />
  );
}
